import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../../services/api/endpoint";
import { hasPermission } from "../../../../services/authentication";
import { Permission } from "../../../../utils/enums";
import UserEditor from "./editor";

const Users: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.UsersList}
			endpoint={Endpoint.Users}
			addScreen={{ screen: UserEditor, isAllowed: hasPermission(Permission.UsersAdd) }}
			editScreen={{ screen: UserEditor, isAllowed: hasPermission(Permission.UsersUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.UsersDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="firstName" title={t("firstName")} />
			<GridColumn field="lastName" title={t("lastName")} />
			<GridColumn field="fullName" title={t("fullName")} />
			<GridColumn field="email" title={t("email")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default Users;
